import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';

import { MDSScenarioCategory } from '../../models/scenarios.interface';
import { ScenarioService } from '../../services/scenario.service';

@Component({
	selector: 'sc-mds-scenario',
	templateUrl: './mds-scenario.component.html',
	styleUrls: ['./mds-scenario.component.scss']
})
export class MdsScenarioComponent implements OnInit {

	@Input() public mdsScenario: MDSScenarioCategory;
	@Input() public isSelected: boolean = false;
	@Output() public onSelect: EventEmitter<any> = new EventEmitter<any>();
	@Output() public onDeselect: EventEmitter<any> = new EventEmitter<any>();

	public imagePath: SafeUrl;
	private scenarioIds: string[];

	constructor(private scenarioService: ScenarioService) { }

	public ngOnInit(): void {
		this.imagePath = this.scenarioService.getImagePath(this.mdsScenario.groupId);
		this.scenarioIds = this.mdsScenario.scenarios.map(scenario => scenario.id);
	}

	public updateSelect(): void {
		this.isSelected = !this.isSelected;

		if (this.isSelected) {
			this.onSelect.emit(this.scenarioIds);
		} else {
			this.onDeselect.emit(this.scenarioIds);
		}
	}
}
